// extracted by mini-css-extract-plugin
module.exports = {"radio":"RadioGroup_radio__bRNeb","input":"RadioGroup_input__Vcp8C","label":"RadioGroup_label__itMUr"};